import { render, staticRenderFns } from "./ProductAbout.vue?vue&type=template&id=04457ca1"
import script from "./ProductAbout.vue?vue&type=script&lang=js"
export * from "./ProductAbout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports